"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.common.help': 'Wspólne awatary są widoczne dla wszystkich użytkowników, ale nie mogą być edytowane przez nie-super-administratorów',
};
